// utils/EnumUtils.js
export function getEnumKey(enumObj, value) {
  return Object.keys(enumObj).find((key) => enumObj[key] === value);
}
